import { Component, OnInit } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiQuery } from '@app/core/http/api-query';
import { environment } from '@env/environment';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { CampaignService } from '@app/campaign/campaign.service';
import { Campaign } from '@app/campaign/campaign.model';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('CampaignViewsComponent');

@Component({
  selector: 'app-campaign-views',
  templateUrl: './campaign-views.component.html',
  styleUrls: ['./campaign-views.component.scss'],
})
export class CampaignViewsComponent implements OnInit {
  campaignId: number;
  campaign: Campaign;
  env = environment;

  eventsRequestsResponse: PaginatedResponse;
  eventsData: GridDataResult;
  eventsState: DataStateChangeEvent;
  eventsApiQuery: ApiQuery = new ApiQuery();

  AuthenticationService = AuthenticationService;

  UserRoleType = UserRoleType;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignService: CampaignService,
    public accessService: AccessService
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      if (params.get('id')) {
        this.campaignId = Number(params.get('id'));
        this.loadData(this.campaignId);
      } else {
        log.error('Id is not found in route params!');
      }
    });
  }

  /**
   *  Парсва стрингосани числа
   * @param number Подава се стрингосано число или число
   */
  number(number: any): number {
    return Number(number);
  }

  loadData(id: number): void {
    const apiQuery: ApiQuery = new ApiQuery().addIncludes(
      'event',
      'event.event_group',
      'sales',
      'sales.sale',
      'creator',
      'template',
      'sales.sale.requests.type',
      'sales.sale.requests.status',
      'sales.sale.client.country',
      'sales.sale.client.city',
      'sales.sale.client.tags',
      'sales.sale.event',
      'sales.sale.event.event_group',
      'sales.sale.sales_agent',
      'sales.sale.customer_care_agent',
      'sales.sale.reservation_agent',
      'sales.sale.company',
      'sales.sale.status',
      'sales.sale.source',
      'sales.sale.assign_to_user'
    );
    this.campaignService.show(id, apiQuery).subscribe((campaign: Campaign) => {
      log.debug(campaign);
      this.campaign = campaign;
    });
  }
}
